import { z } from 'zod';
export const OrganizationStatus = z.enum(['active', 'inactive', 'deleted']);
export const UserStatus = z.enum(['active', 'invited', 'disabled']);
export const MembershipStatus = z.enum(['active', 'invited', 'suspended']);
export const PermissionEffect = z.enum(['grant', 'deny']);
/** ISO-3166-1 alpha-2, kept as a free 2-letter string (not hard-coded list). */
export const CountryCode = z
    .string()
    .length(2)
    .transform((s) => s.toUpperCase());
//# sourceMappingURL=enums.js.map